import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 404 页面 · 与 ErrorBoundary 视觉风格对齐
 * 通配路由 "*" 兜底，显示访问的 URL 并给出"回首页 / 返回上一页"两个出路。
 */
export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: 'linear-gradient(160deg, #F2F6F0 0%, #E8F0E4 100%)' }}
    >
      <div
        className="w-full max-w-lg rounded-2xl p-8 relative overflow-hidden"
        style={{
          background: '#fff',
          boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          border: '1px solid rgba(180,195,175,0.3)',
        }}
      >
        {/* 背景大字 404 */}
        <span
          className="absolute right-4 bottom-0 text-[10rem] font-black select-none pointer-events-none leading-none"
          style={{ color: 'rgba(180,195,175,0.12)' }}
          aria-hidden
        >
          404
        </span>

        <div className="relative z-10">
          <div className="flex items-center gap-3 mb-5">
            <div
              className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
              style={{ background: 'rgba(110,143,174,0.12)' }}
            >
              <i
                className="ri-compass-discover-line text-2xl"
                style={{ color: '#6E8FAE' }}
              ></i>
            </div>
            <div>
              <h1
                className="text-lg font-semibold"
                style={{ color: '#2C3E2D', fontFamily: '"Noto Serif SC", serif' }}
              >
                页面不见了
              </h1>
              <p className="text-xs mt-0.5" style={{ color: '#8AAA8A' }}>
                你访问的链接似乎已经失效
              </p>
            </div>
          </div>

          <p
            className="text-sm mb-6 font-mono break-all"
            style={{ color: '#8A9AAA', background: 'rgba(110,143,174,0.06)', padding: '8px 12px', borderRadius: '10px' }}
          >
            {location.pathname}
          </p>

          <div className="flex gap-3">
            <button
              onClick={() => navigate(-1)}
              className="flex-1 py-2.5 rounded-xl text-sm cursor-pointer whitespace-nowrap"
              style={{ background: 'rgba(180,195,175,0.15)', color: '#5C7A5C' }}
            >
              <i className="ri-arrow-left-line mr-1.5"></i>返回上一页
            </button>
            <button
              onClick={() => navigate('/')}
              className="flex-1 py-2.5 rounded-xl text-sm cursor-pointer whitespace-nowrap"
              style={{ background: 'linear-gradient(135deg, #6B9E6B, #5A8A5A)', color: '#fff' }}
            >
              <i className="ri-home-4-line mr-1.5"></i>回到首页
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
